import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import axios from 'axios';

import { Row, Col, Button, Card, CardHeader, CardFooter, CardBody, Form, FormGroup, Label, Input, Alert } from 'reactstrap';

import * as vars from '../../constants/variables';

import { show, hide } from "../../actions/ActivityIndicatorActions";
import { getGameTypes, getCategories } from "../../actions/CategoryActions";

import { console_log, parseQueryString } from '../../utils/helper';
import { config } from '../../constants/domainConfig';
const arabicDomain = (config.lang == 'ar') ? true : false;

var data = new FormData();

class Uploads extends Component {
    constructor(props) {
        super(props);
        this.state = {
            gameTitle: '',
            gameDesc: '',
            gameImage: false,
            gameFile: false,
            gameType: '',
            platforms: '',
            categoryId: 0,
            categoryTypeId: 0,
            isValid: false,
            errorMessage: ''
        };

        this.isValid = this.isValid.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.onChange = this.onChange.bind(this);
    }

    componentWillMount() {
        this.getGameTypes();
        this.getCategories();
    }

    componentDidUpdate() {
        if (!this.props.user.isAuthenticated) {
            this.props.history.push('/login');
        }
    }

    getGameTypes() {
        axios.get(vars.BASE_URL+'/getCategoryTypes')
            .then((response) => {
                if (response.data.success) {
                    this.props.getGameTypes(response.data);
                }
            })
            .catch((error) => {
                console_log(error);
                this.setState({ isValid: false, errorMessage: 'Unable to fetch the data.'});
            });
    }

    getCategories() {
        this.props.show();
        axios.get(vars.BASE_URL+'/getCategories')
            .then((response) => {
                this.props.hide();
                if (response.data.success) {
                    let dataFinal = response.data;
                    let categoriesArr = dataFinal.data; 
                    dataFinal = { ...dataFinal, data: categoriesArr };
                    if(!(config.subDomain === 'cz' && isGamiclub)){
                        dataFinal.data = dataFinal.data.filter(category => {
                            return category.categoryName != 'E-knihy'
                        })
                    }
                    if(config.subDomain === 'fr' && isGamiclub) {
                        dataFinal.data = dataFinal.data.filter(category => {
                            return category.categoryName != 'Heróis Verdes'
                        })
                    }
                    if(config.subDomain === 'my' && window.location.hostname.includes('gamiclub')) {
                        dataFinal.data = dataFinal.data.filter(category => {
                            let excludes = ["E-Learning", "Heróis Verdes", "Meu Emprego dos Sonhos", "Political & Activism"]
                            return excludes.indexOf(category.categoryName) == -1
                        })
                    }
                    if(config.subDomain === 'es2' && window.location.hostname.includes('beemobi')) {
                        dataFinal.data = dataFinal.data.filter(category => {
                            let excludes = ["E-Learning", "Heróis Verdes", "Meu Emprego dos Sonhos"]
                            return excludes.indexOf(category.categoryName) == -1
                        })
                    }
                    else {
                        dataFinal.data = dataFinal.data.filter(category => {
                            return category.categoryName != 'Videos Virales'
                        })
                    }
                    if(config.subDomain !== 'rs'){
                        dataFinal.data = dataFinal.data.filter(category => {
                            return category.categoryName != 'Е-књиге'
                        })
                    }
                    if(config.subDomain !== 'tr' && config.subDomain !== 'qa' && config.subDomain !== 'kw'){
                        dataFinal.data = dataFinal.data.filter(category => {
                            return category.categoryName != 'Facebook'
                        })
                    }
                    this.props.getCategories(dataFinal);
                }
            })
            .catch((error) => {
                this.props.hide();
                console_log(error);
                this.setState({ isValid: false, errorMessage: 'Unable to fetch the data.'});
            });
    }

    onChange(e) {
        switch (e.target.name) {
            case 'gameImage' : {
                data.append('gameImage', e.target.files[0]);
                this.setState({
                    gameImage: (typeof e.target.files[0] == 'object') ? true : false
                });
                break;
            }
            case 'gameFile' : {
                data.append('gameFile', e.target.files[0]);
                this.setState({
                    gameFile: (typeof e.target.files[0] == 'object') ? true : false
                });
                break;
            }
            case 'categoryId' : {
                this.setState({
                    gameType: e.target.options[e.target.selectedIndex].title.split('_')[1],
                    platforms: (e.target.options[e.target.selectedIndex].title.split('_')[1] == 'html5') ? 'html5' : 'android',
                    categoryId: e.target.value,
                    categoryTypeId: e.target.options[e.target.selectedIndex].title.split('_')[0]
                });
                break;
            }
            default: {
                this.setState({
                    [e.target.name]: e.target.value
                });
            }
        }
    }

    isValid() {
        if (this.state.gameTitle == '') {
            this.setState({
                isValid: false,
                errorMessage: "Please enter game title."
            });
            return false;
        }
        if (this.state.gameDesc == '') {
            this.setState({
                isValid: false,
                errorMessage: "Please enter game description."
            });
            return false;
        }
        if (!this.state.gameFile) {
            this.setState({
                isValid: false,
                errorMessage: "Please enter game zip file."
            });
            return false;
        }
        if (!this.state.gameImage) {
            this.setState({
                isValid: false,
                errorMessage: "Please enter game image."
            });
            return false;
        }
        if (this.state.categoryId == 0) {
            this.setState({
                isValid: false,
                errorMessage: "Please select a category for the game."
            });
            return false;
        }

        return true;
    }

    onSubmit(e) {
        e.preventDefault();

        if(this.isValid()){
            this.setState({ isValid: true, errorMessage: ''});
            this.addGame();
        }
    }

    addGame() {
        data.append('gameTitle', this.state.gameTitle);
        data.append('gameDesc', this.state.gameDesc);
        data.append('categoryId', this.state.categoryId);
        data.append('categoryTypeId', this.state.categoryTypeId);
        data.append('platforms', this.state.platforms);
        data.append('gameType', this.state.gameType);

        this.props.show();
        axios.post(vars.BASE_URL+'/addGame', data)
            .then((response) => {
                this.props.hide();
                if (response.data.success) {
                    this.setState({
                        gameTitle: '',
                        gameDesc: '',
                        gameImage: false,
                        gameFile: false,
                        gameType: '',
                        platforms: '',
                        categoryId: 0,
                        categoryTypeId: 0
                    });
                }
                this.forceUpdate();
            })
            .catch((error) => {
                this.props.hide();
                console_log(error);
                this.setState({ isValid: false, errorMessage: 'Sorry, unable to add game details, please try again later.'});
            });
    }

    render() {
        return (
            <div className="uploads animated fadeIn">
                <Row>
                    <Col xs="12" md="12">
                        <Card>
                            <CardHeader>
                                <strong>Upload Games</strong>
                            </CardHeader>
                            <CardBody>
                                <Form action="" method="post" encType="multipart/form-data" className="form-horizontal">
                                    <FormGroup row>
                                        <Col md="3">
                                            <Label htmlFor="gameTitle">Game Title</Label>
                                        </Col>
                                        <Col xs="12" md="9">
                                            <Input type="text" id="gameTitle" name="gameTitle" placeholder="Game Title" value={this.state.gameTitle} onChange={this.onChange}/>
                                        </Col>
                                    </FormGroup>
                                    <FormGroup row>
                                        <Col md="3">
                                            <Label htmlFor="gameDesc">Game Description</Label>
                                        </Col>
                                        <Col xs="12" md="9">
                                            <Input type="textarea" id="gameDesc" name="gameDesc" placeholder="Game Description" value={this.state.gameDesc} onChange={this.onChange}/>
                                        </Col>
                                    </FormGroup>
                                    <FormGroup row>
                                        <Col md="3">
                                            <Label htmlFor="gameImage">Game Image</Label>
                                        </Col>
                                        <Col xs="12" md="9">
                                            <Input type="file" id="gameImage" name="gameImage" placeholder="Game Image" onChange={this.onChange}/>
                                        </Col>
                                    </FormGroup>
                                    <FormGroup row>
                                        <Col md="3">
                                            <Label htmlFor="gameFile">Game File</Label>
                                        </Col>
                                        <Col xs="12" md="9">
                                            <Input type="file" id="gameFile" name="gameFile" placeholder="Game File" onChange={this.onChange}/>
                                        </Col>
                                    </FormGroup>
                                    <FormGroup row>
                                        <Col md="3">
                                            <Label htmlFor="categoryId">Games Categories</Label>
                                        </Col>
                                        <Col xs="12" md="9">
                                            <Input type="select" name="categoryId" id="categoryId" onChange={this.onChange} value={this.state.categoryId} >
                                                <option value="0">Category</option>
                                                {(this.props.categories.categories.length > 0) ?
                                                    this.props.categories.categories.map((c) => {
                                                        return (
                                                            <option key={c.categoryId} value={c.categoryId} gametype={c.categoryTypeName.toLocaleLowerCase()} title={c.categoryTypeId + '_' + c.categoryTypeName.toLowerCase()}>{c.categoryName +" [" + c.categoryTypeName + "]"}</option>
                                                        )
                                                    })
                                                    : ''
                                                }
                                            </Input>
                                        </Col>
                                    </FormGroup>
                                    {(!this.state.isValid && this.state.errorMessage != '') ?
                                        <Alert color="danger">{this.state.errorMessage}</Alert> : ''}
                                </Form>
                            </CardBody>
                            <CardFooter  className="card-footer-align-right">
                                <Button type="submit" color="primary" onClick={this.onSubmit}><i className="fa fa-upload"></i> Upload</Button>
                            </CardFooter>
                        </Card>
                    </Col>
                </Row>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        user: state.AuthenticationReducer,
        access: state.WelcomeReducer,
        domains: state.DomainReducer,
        country: state.CountryReducer,
        users: state.UsersReducer,
        categories: state.CategoryReducer
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        show,
        hide,
        getGameTypes,
        getCategories
    }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(Uploads);


// WEBPACK FOOTER //
// ./src/components/Uploads/Uploads.js